import { api } from '@/services/api/AxiosBaseService'
import { createCrudService } from '@/services/api/createCrudService'

export interface Hierarchy {
  id: string
  name: string
  authorities: string[]
  status: 'ATIVO' | 'INATIVO'
  formatted?: { createdAt?: string }
}

export interface PermissionItem { key: string; label: string; description?: string }
export interface PermissionResource { key: string; label: string; permissions: PermissionItem[] }
export interface PermissionGroup { key: string; label: string; description?: string; resources: PermissionResource[] }

const base = createCrudService<Hierarchy>('/administractive/hierarchies', { searchField: 'name' })

export const HierarchiesService = {
  ...base,
  /** Catálogo de permissões (fonte única), agrupado por módulo. */
  async permissionsCatalog(): Promise<PermissionGroup[]> {
    const r = await api.get<{ data: PermissionGroup[] }>('/administractive/hierarchies/permissions-catalog')
    return r.data.data
  },
}
